'use strict';
//Utilities
var React = require('react');
var ClassNames = require('classnames');
var Spinner = require('./Spinner.jsx');
var ApplicationConstants = require('../../constants/ApplicationConstants.js');
var InlineMessage = require('./InlineMessage.jsx');
var InlineError = require('./InlineError.jsx');

var RadioButton = React.createClass({
    propTypes: {
        id: React.PropTypes.string.isRequired,
        onChange: React.PropTypes.func,        
        label: React.PropTypes.string,
        value: React.PropTypes.bool,
        model: React.PropTypes.string,
        prefix: React.PropTypes.string,
        isDisabled:React.PropTypes.bool,
        isHidden: React.PropTypes.bool,
        contextualMessage: React.PropTypes.string,
        errorHeading: React.PropTypes.string,
        errorMessage: React.PropTypes.string,
        errorList: React.PropTypes.array
    },
    getDefaultProps: function() {
        return {            
            isHidden: false,
            isDisabled:false
        };
    },
    inlineErrorMessage: function() {
        var errorMessage = null;
        //if errorList is passed, use it otherwise use errorHeading / errorText 
        if(this.props.errorList) {
            var errorOfTheField = _.filter(this.props.errorList, { id: this.props.id });
            if (errorOfTheField.length > 0 && errorOfTheField[0]) {
                errorMessage = (<InlineMessage key={this.props.key} 
                                               id={'inline-message-' + this.props.id} 
                                               isHidden={!errorOfTheField[0].message} 
                                               type={errorOfTheField[0].type || ApplicationConstants.messageTypes.error}
                                               message={errorOfTheField[0].message}
                                               errorClickHandler={this.props.errorClickHandler} />);
            } 
        } else if (this.props.errorHeading || this.props.errorMessage){
            errorMessage =  <InlineError className="alert alert-warning" isHideError={this.props.errorList || this.props.isValid} header={this.props.errorHeading || 'Invalid ' + this.props.label} message={this.props.errorMessage} />;
        }
        return errorMessage; 
    },   

    handleOnChange: function(event) {
        if(this.props.onChange){            
            //Instead of passing the id of input element, component id will be passed for validation message
            this.props.onChange({target: {id: this.props.id, value: event.target.value === 'false', model: this.props.model}});
        }
    },

    render: function() {
        if (this.props.isHidden) {
            return null;
        }
        var hideSpinner = this.props.label && this.props.label.length > 0;
        //var spinner = <Spinner size={ApplicationConstants.SpinnerSizes.Three} />;       
        var prefixText = this.props.prefix && this.props.prefix.length > 0 ? (<div className="radio-button-prefix" dangerouslySetInnerHTML={{ __html: this.props.prefix }} />) : null;
        var labelText = this.props.label && this.props.label.length > 0 ? (<div className="radio-button-label" dangerouslySetInnerHTML={{ __html: this.props.label }} />) : null;
        var inputKey = 'input-' + this.props.id;
        
        return (
            
            <div className="form-section">
                <div className="form-label-section">  
                    {hideSpinner ? 
                    (
                        <div className="form-select">   
                            {prefixText}
                            <label htmlFor={inputKey} tabIndex="0"                             
                                onChange={this.handleOnChange} 
                                disabled={this.props.isDisabled}
                                className={ClassNames('radio-button', { 'btn-cfs' : this.props.value}) }>
                                <i className={ClassNames('icon',{ 'icon-check' : this.props.value},{ 'icon-uncheck' : !this.props.value})}></i>
                                <input id={inputKey} tabIndex="-1" name={this.props.id} type="radio" 
                                    className="btn-option btn btn-default btn-lg" 
                                    disabled={this.props.isDisabled} 
                                    value={this.props.value} 
                                    onChange={this.handleOnChange} 
                                    checked={this.props.value} />
                            </label>
                            {labelText}
                        </div>
                    )
                    :(<Spinner size={ApplicationConstants.SpinnerSizes.Three} />)}
                </div> 
                { //don't display contextual message when there is error message
                    this.inlineErrorMessage() || 
                    <InlineMessage key={'inline-message-'+this.props.id}
                                   id={'contextual-message-' + this.props.id}
                                   type={ApplicationConstants.messageTypes.info}
                                   message={this.props.contextualMessage}
                                   isHidden={!this.props.contextualMessage} />  
                }
                               
            </div>
        );
    }
});

module.exports = RadioButton;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Common/RadioButton.jsx